import { render, staticRenderFns } from "./l30.vue?vue&type=template&id=becdc12e&scoped=true&"
import script from "./l30.vue?vue&type=script&lang=js&"
export * from "./l30.vue?vue&type=script&lang=js&"
import style0 from "./l30.vue?vue&type=style&index=0&id=becdc12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becdc12e",
  null
  
)

export default component.exports